import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Footer } from '../Components/Footer';
import HeroContainer from '../Components/ui/hero-container';
import Button from '../Components/ui/button/Button';
import ButtonOutline from '../Components/ui/button/ButtonOutline';
import FreeTrial from '../Components/about-page/free-trial';
import CollegeCounselingModal from '../Components/college-counseling/CollegeCounselingModal';
import HeaderAlt from '../Components/HeaderAlt';

const feature = [
  {
    title: 'Discover Colleges',
    desc: 'Our AI-powered platform helps students explore a vast range of colleges tailored to their preferences. By analyzing factors like location, programs, and student reviews, it makes the process of discovering the right college simple and efficient. With this tool, students can uncover hidden gems and broaden their options for higher education.',
    img: '/images/college-counselling/cc-img1.png',
  },
  {
    title: 'Get Detailed College Report',
    desc: "Our AI College Counselor provides personalized and detailed reports for each college. These reports cover critical aspects such as academic strengths, campus life, and financial aid opportunities, offering a complete picture of the colleges you're considering. With this data at your fingertips, you can confidently evaluate and narrow down your options.",
    img: '/images/college-counselling/cc-img2.png',
  },
  {
    title: 'Receive a fit estimation',
    desc: 'Wondering which college is the best match for you? Our platform offers a personalized fit estimation by assessing your academic profile, interests, and goals. This feature helps you identify colleges where you’re most likely to thrive, ensuring a smoother and more rewarding college journey.',
    img: '/images/college-counselling/cc-img3.png',
  },
  {
    title: 'Stay Updated',
    desc: 'Get the latest updates on colleges, including academic offerings, campus news, and scholarship opportunities. With our AI College Counselor, students can stay informed and prepared to make the best decisions for their future.',
    img: '/images/college-counselling/cc-img4.png',
  },
];

const CollegeCounseling = () => {
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();

  return (
    <div className="flex-container">
      <HeaderAlt />
      <div>
        <HeroContainer className="flex py-14 pb-14">
          <div className="container flex flex-col gap-4 md:flex-row">
            <div className="  mx-auto flex-1 space-y-6 !pt-2 text-left ">
              <h1 className="hero-title fredokaOne relative text-center  md:text-left">
                Find Guidance to choose the right college
              </h1>
              <p className="fredoka  max-w-[490px] text-center text-[18px] font-medium leading-[145.55%] tracking-[-0.22px] text-[#678285] md:text-left md:text-[22px]">
                Personalized support to guide you through your college curation journey
              </p>
              <div className="flex w-full flex-col-reverse gap-4 md:flex-row">
                <Button
                  className="text-base md:!w-fit"
                  onClick={() => setShowModal(true)}
                  label={'Book Consultation'}
                />
                <ButtonOutline
                  className="md:!w-fit"
                  onClick={() => navigate('/waitlist')}
                  label={'Try AI Product'}
                />
              </div>
              <CollegeCounselingModal open={showModal} handleClose={() => setShowModal(false)} />
              <div className="flex justify-center md:justify-start">
                <img
                  className="max-w-[15rem] md:max-w-xs"
                  src="/images/college-counselling/free-for-students.png"
                  alt=""
                />
              </div>
            </div>
            <div className="flex-1">
              <img
                src="/images/college-counselling/sol2-hero-img.png"
                alt="hero-img"
                className=""
              />
            </div>
          </div>
        </HeroContainer>
        <div className="mx-auto mt-10 max-w-[606px] space-y-6 px-6 md:mt-14 md:px-0">
          <h1 className="fredokaOne text-center text-[32px] font-normal leading-tight tracking-[-0.64px] text-[#012E33] md:text-[40px] md:tracking-[-0.8px]">
            Personalized AI College Counselling
          </h1>
          <p className="text-center font-[Fredoka] text-[18px] font-normal leading-normal tracking-[-0.18px] text-[#678285] md:text-[22px] md:leading-[32px] md:tracking-[-0.22px]">
            Our AI College Counselor helps high school students find universities that match their
            unique profiles, considering academics, sports, location, and finances for tailored
            recommendations.
          </p>
        </div>
        <div className="container !mt-[34px] md:!mt-[46px] ">
          <div className="grid grid-cols-1 gap-5 md:grid-cols-2">
            {feature.map((data, i) => (
              <div
                key={i}
                className="flex h-full flex-col space-y-2 rounded-[24px] bg-gradient-to-r from-[#FFF] via-[#F7F7F7] to-[#F7F7F7] [background-size:200%_100%]"
              >
                <div className="flex-shrink-0 p-4">
                  <img
                    src={data.img}
                    alt=""
                    className="h-[200px] w-full rounded-t-[24px] object-contain"
                  />
                </div>
                <div className="flex-grow space-y-6 p-6 md:space-y-2 md:p-10">
                  <h4 className="font-[Fredoka] text-[32px] font-medium leading-normal tracking-[-0.64px] text-[#012E33]">
                    {data.title}
                  </h4>
                  <p className="font-[Fredoka] text-[22px] font-normal leading-[32px] tracking-[-0.22px] text-[#678285] md:text-[18px] md:leading-[26px] md:tracking-[-0.36px]">
                    {data.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
          <div className="mx-auto mt-10 max-w-[200px]">
            <Button onClick={() => navigate('/waitlist')} label={'Try AI Product'} />
          </div>
          <hr className="!container !mx-auto mt-14" />
        </div>
        <div className="mx-auto mt-16 max-w-[606px] space-y-[18px] px-6 md:space-y-6 md:p-0">
          <h1 className="text-center font-[Fredoka] text-[40px] font-semibold leading-normal tracking-[-0.8px] text-[#012E33]">
            In-Person College Counseling in Texas
          </h1>
          <p className="text-center font-[Fredoka] text-[18px] font-normal leading-[32px] tracking-[-0.18px] text-[#678285] md:text-[22px] md:tracking-[-0.22px]">
            We provide in-person college counseling services in the Houston area through our IAMAI
            partner network.
          </p>
          <div className="flex flex-col-reverse gap-2 px-4 md:flex-row md:gap-4">
            <div className="w-full">
              <Button label={'Book Consultation'} onClick={() => setShowModal(true)} />
              <p className="mt-2 text-center text-[12px] font-normal leading-normal tracking-[-0.12px] text-[#012E33]">
                Via Partner Network
              </p>
            </div>
            <ButtonOutline onClick={() => navigate('/partnerships')} label={'Partner with us'} />
          </div>
        </div>
        <hr className="!container !mx-auto mb-[40px] mt-[32px] md:mb-[139px] md:mt-16" />
        <div className="container">
          <FreeTrial />
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default CollegeCounseling;
